import React, { useState, useRef } from "react"
import HireDevelopersModal from "./HireDevelopersModal";
import Collapse from 'react-bootstrap/Collapse';
import Card from 'react-bootstrap/Card';
import { useLocation } from '@reach/router';
import { graphql, Link, useStaticQuery } from "gatsby";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import OfferRunner from "./OfferRunner";

export default function Navbar() {

    const [showMegaMenu, setShowMegaMenu] = useState(false);
    const timerRef = useRef(null);
    const location = useLocation();
    const currentPath = location.pathname;

    const handleMouseEnter = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setShowMegaMenu(true);
    };

    const handleMouseLeave = () => {
        timerRef.current = setTimeout(() => {
            setShowMegaMenu(false);
            timerRef.current = null;
        }, 300);
    };

    const data = useStaticQuery(graphql`
        query {
            allFile(
                filter: {
                    relativeDirectory: { eq: "logo" }, 
                    extension: {regex: "/(jpg|jpeg|png)/"}
                }
            ) {
                edges {
                    node {
                        name
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
                        }   
                    }
                }
            }
        }   
  `);

    let images = {};
    data.allFile.edges.forEach(edge => {
        images[edge.node.name] = getImage(edge.node.childImageSharp);
    });

    return (
        <>
            {/*<OfferRunner />*/}
            <header className={'no-sticky'}>
                <nav className="navbar navbar-expand-lg header-light header-transparent bg-transparent disable-fixed">
                    <div className="container-fluid">
                        <div className="col-auto col-lg-2 me-lg-0 me-auto">
                            <Link className="navbar-brand" to="/">
                                {images['logo_full'] && (
                                    <GatsbyImage
                                        image={images['logo_full']}
                                        data-at2x="images/demo-web-agency-logo-black@2x.png"
                                        alt="Matrixbrains pvt ltd company logo"
                                        className="default-logo"
                                        loading="lazy"
                                    />
                                )}
                                {images['logo_full'] && (
                                    <GatsbyImage
                                        image={images['logo_full']}
                                        data-at2x="images/demo-web-agency-logo-black@2x.png"
                                        alt="Matrixbrains pvt ltd company logo"
                                        className="alt-logo"
                                        loading="lazy"
                                    />
                                )}
                                {images['mobile-logo'] && (
                                    <GatsbyImage
                                        image={images['mobile-logo']}
                                        data-at2x="images/demo-web-agency-logo-black@2x.png"
                                        alt="Matrixbrains pvt ltd company small logo"
                                        className="mobile-logo h-55px w-55px"
                                        loading="lazy"
                                        imgStyle={{
                                            height: "56px",
                                            width: "56px",
                                        }}
                                    />
                                )}
                            </Link>
                        </div>
                        <div className="col-auto col-lg-8 menu-order position-static">
                            <button className="navbar-toggler float-start" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-label="Toggle navigation">
                                <span className="navbar-toggler-line" />
                                <span className="navbar-toggler-line" />
                                <span className="navbar-toggler-line" />
                                <span className="navbar-toggler-line" />
                            </button>
                            <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
                                <ul className="navbar-nav">
                                    <li className={`nav-item ${currentPath === '/' ? 'active' : ''}`}>
                                        <Link to="/" className="nav-link">Home</Link>
                                    </li>
                                    <li className={`nav-item ${currentPath === '/cloud-support/' ? 'active' : ''}`}>
                                        <Link to="/cloud-support" className="nav-link">Cloud Support</Link>
                                    </li>
                                    <li className={`nav-item ${currentPath === '/agency-about/' ? 'active' : ''}`}>
                                        <Link to="/agency-about" className="nav-link">Agency</Link>
                                    </li>
                                    <li className={`nav-item ${currentPath === '/expertise/' ? 'active' : ''}`}>
                                        <Link to="/expertise" className="nav-link">Expertise</Link>
                                    </li>
                                    <li className={`nav-item ${currentPath === '/portfolio/' ? 'active' : ''}`}>
                                        <Link to="/portfolio" className="nav-link">Portfolio</Link>
                                    </li>
                                    <li className={`nav-item ${currentPath === '/people/' ? 'active' : ''}`}>
                                        <Link to="/people" className="nav-link">People</Link>
                                    </li>
                                    <li className={`nav-item ${currentPath === '/blog/' ? 'active' : ''}`}>
                                        <Link to="/blog" className="nav-link">Blog</Link>
                                    </li>
                                    <li
                                        className={`nav-item ${currentPath === '/hire-developers/' ? 'active' : ''}`}
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <Link to='#' className="nav-link">Hire Developer</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-auto col-lg-2 text-end">
                            <div className="header-icon">
                                <div className="header-button">
                                    <Link to="/contact" className="btn btn-rounded btn-dark-gray btn-medium btn-switch-text btn-box-shadow text-transform-none btn-hover-base">
                                        <span>
                                          <span className="btn-double-text" data-text="Contact">Contact</span>
                                          <span><i className="fa-solid fa-arrow-right" /></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
            <Collapse
                in={showMegaMenu}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Card className="navbar__mega-menu mt-4">
                    <HireDevelopersModal />
                </Card>
            </Collapse>
        </>
    )
}
